import {
  DEFAULT_ARTIFACT_ICON,
  ExternalUrlArtifactContent,
  ExternalUrlArtifactListItem,
  createArtifactExtension,
  isExternalLink,
  isGoogleDocUrl,
} from '@spotify/plugin-confidence-projects-react';

import { projectsPlugin } from '../plugin';

export const LinkArtifactExtension = projectsPlugin.provide(
  createArtifactExtension({
    id: 'link',
    predicate: artifact =>
      isExternalLink(artifact.uri) && !isGoogleDocUrl(artifact.uri),
    icon: () => DEFAULT_ARTIFACT_ICON,
    label: 'Link',
    category: 'Links',
    render: artifact => (
      <ExternalUrlArtifactContent artifact={artifact} href={artifact.uri}  data-track-source-anchor="efa0268ba7;link-artifact-extension-external-url-artifact"/>
    ),
    renderListItem: (artifact, { onDelete, onRename, icon }) => (
      <ExternalUrlArtifactListItem
        artifact={artifact}
        icon={icon}
        subtitleLabel="Link"
        openLabel="Open link"
        href={artifact.uri}
        onDelete={onDelete}
        onRename={onRename}
       data-track-source-anchor="ac0bbe532e;link-artifact-extension-external-url-artifact-2"/>
    ),
  }),
);
